import PropTypes from 'prop-types'
import { memo, forwardRef } from 'react'
import { Box } from '@mui/material'
import { StyledRootScrollbar, StyledScrollbar } from './styles'

const Scrollbar = forwardRef(({ children, sx, ...other }, ref) => {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)

  if (isMobile) {
    return (
      <Box ref={ref} sx={{ overflowX: 'auto', ...sx }} {...other}>
        {children}
      </Box>
    )
  }

  return (
    <StyledRootScrollbar>
      <StyledScrollbar ref={ref} clickOnTrack={false} autoHide={false} sx={sx} {...other}>
        {children}
      </StyledScrollbar>
    </StyledRootScrollbar>
  )
})

Scrollbar.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.node,
}

export default memo(Scrollbar)
